import { action } from 'satcheljs';
import { TableView } from 'owa-mail-list-store';

export default action(
    'markReadOnTableViewChange',
    (oldSelectedRowKeys: string[], oldTableView: TableView, newTableView: TableView) => ({
        oldSelectedRowKeys,
        oldTableView,
        newTableView,
    })
);
